export default ({ Factory }) => ({

  /**
   * Создание серии
   * @param {Object} series - серия 
   */
  create: (series) => Factory.post(series),

  /**
   * Обновление серии
   * @param {Object} series - серия
   */
  update: (series) => Factory.put(series),

  /**
   * Удаление серии
   * @param {String} id - идентификатор серии
   */
  remove: (id) => Factory[id].delete(),
  
  /**
   * Список серий
   * @param {*} channel - идентификатор канала
   * @param {*} user - идентификатор пользователя
   */
  list: (channel, user) => {
    let params = `?channel=${channel}&user=${user}`
    return Factory.list[params].get()
  },

  /**
   * Список всех серий
   */
  all: () => Factory.list.get(),

  /**
   * Получение серии
   * @param {String} id - идентификатор серии
   */
  get: (id) => Factory[id].get(),

  /**
   * Получение списка пользователей серий по каналу
   * @param {String} id - идентификатор канала
   */
  users: (id) => Factory.users.channel[id].get(),
})